import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InAppNotificationPreferencesEffects } from 'src/app/in-app-notifications/store/effects/in-app-notification-preferences.effects';
import { inAppNotificationPreferencesReducer } from 'src/app/in-app-notifications/store/reducers/in-app-notification-preferences.reducer';
import { inAppNotificationPreferencesFeatureKey } from 'src/app/in-app-notifications/store/selectors/in-app-notification-preferences.selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(inAppNotificationPreferencesFeatureKey, inAppNotificationPreferencesReducer),
        EffectsModule.forFeature([InAppNotificationPreferencesEffects])
    ]
})
export class InAppNotificationPreferencesStoreModule {}
